import Vue from 'vue';
import { runtime, type Track } from './bridge';

export const playlistTarget = Vue.observable({ visible: false, track: null as Track | null });
let opener: HTMLElement | null = null;

export function openPlaylistTarget(track: Track, anchor?: HTMLElement) {
  opener = anchor || (document.activeElement instanceof HTMLElement ? document.activeElement : null);
  // Fix the chosen recording while the global Space shortcut can keep playing.
  playlistTarget.track = { ...track, artists: [...track.artists] };
  runtime.ui.queueOpen = false; runtime.ui.audioSettingsOpen = false;
  playlistTarget.visible = true;
}

export function closePlaylistTarget() {
  playlistTarget.visible = false;
  const anchor = opener;
  Vue.nextTick(() => { if (!playlistTarget.visible && anchor?.isConnected && anchor.getClientRects().length) anchor.focus({ preventScroll: true }); });
}
